import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import {
  VehicleRecurrence,
  VehicleRecurrenceUpsertParams,
  VehicleStatusResponse,
} from '../core/type';

interface PaginatedResponse<T> {
  items: T[];
  total: number;
}

@Injectable({ providedIn: 'root' })
export class VehicleRecurrenceApiService {
  private readonly baseUrl = `${environment.apiHost}/veiculos`;

  constructor(private http: HttpClient) {}

  upsert(params: VehicleRecurrenceUpsertParams): Observable<VehicleRecurrence> {
    return this.http.post<VehicleRecurrence>(
      `${this.baseUrl}/recorrencia`,
      params,
    );
  }

  findAll(
    pageIndex = 1,
    pageSize = 1000,
    searchString?: string,
    onlyActive?: boolean,
  ): Observable<PaginatedResponse<VehicleRecurrence>> {
    const params: any = { pageIndex, pageSize };
    if (searchString) params.searchString = searchString;
    if (onlyActive !== undefined) params.onlyActive = String(onlyActive);
    return this.http.get<PaginatedResponse<VehicleRecurrence>>(
      `${this.baseUrl}/recorrencia`,
      { params },
    );
  }

  findByChassis(chassis: string): Observable<VehicleRecurrence> {
    return this.http.get<VehicleRecurrence>(
      `${this.baseUrl}/recorrencia/${encodeURIComponent(chassis)}`,
    );
  }

  delete(chassis: string): Observable<{ success: boolean }> {
    return this.http.delete<{ success: boolean }>(
      `${this.baseUrl}/recorrencia/${encodeURIComponent(chassis)}`,
    );
  }

  getVehiclesStatus(): Observable<VehicleStatusResponse> {
    return this.http.get<VehicleStatusResponse>(
      `${this.baseUrl}/status-checklist`,
    );
  }
}
